enum ProjectStates {
  capturing = "capturing",
  paused = "paused",
  error = "error",
}

export { ProjectStates };
